<template>
  <el-collapse-transition>
    <div class="app-pwa-installer"
         v-show="isShown">
      <div>{{ $t('PWA_INSTALLER.TITLE') }}</div>
      <div class="actions">
        <el-button :aria-label="$t('ACTIONS.CLOSE')"
                   @click="close"
                   circle
                   icon="el-icon-close">
        </el-button>
        <el-button @click="prompt"
                   round
                   type="primary">
          {{ $t('ACTIONS.INSTALL') }}
        </el-button>
      </div>
    </div>
  </el-collapse-transition>
</template>

<script>
export default {
  name: 'AppPwaInstaller',
  data () {
    return {
      isShown: false,
      promptEvent: null
    }
  },
  created () {
    window.addEventListener('beforeinstallprompt', event => {
      event.preventDefault()
      this.promptEvent = event
      this.isShown = true
    })
  },
  methods: {
    prompt () {
      this.promptEvent.prompt()
      this.close()
    },
    close () {
      this.isShown = false
    }
  }
}
</script>

<style lang="scss" scoped>
.app-pwa-installer {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: white;
  border-top: 1px solid #DCDFE6;
  padding: 1rem;

  .actions {
    text-align: right;
    margin-top: 1rem;
  }
}
</style>
